var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Chip } from "@mui/material";
const PrimaryChip = (_a) => {
    var props = __rest(_a, []);
    return (React.createElement(Chip, Object.assign({ variant: "soft", color: "primary", sx: {
            borderRadius: 3,
            background: "#3192D026",
            color: "#2476A9",
            fontSize: "13px",
            fontWeight: 500,
        }, size: "medium" }, props)));
};
export default PrimaryChip;
